module.exports = __webpack_public_path__ + "static/media/digital_guide_book_language.7a905de8.png";